import { runPollyfills } from "./js/utils/polyfills";
runPollyfills();

import debounce from "debounce";
import { exec } from "./js/main";
import g from "./js/utils/globals";
import api from "./js/utils/api";
import proxy from "./js/proxy";
import dom from "./js/utils/dom";
import * as urls from "./js/utils/urls";
import at from "./js/utils/at";
import * as features from "./js/utils/features";
import * as enhancementsHelper from "./js/utils/enhancementsHelper";
import * as helpers from "./js/utils/helpers";
import ajax from "./js/utils/ajax";
import * as analytics from "./js/utils/analytics";
import cookies from "./js/utils/cookies";
import Logger from "./js/utils/Logger";
import Componentes from "./js/components/index";
import L10N from "./js/utils/l10n";
import time from "./js/utils/time";
import mode from "./js/utils/mode";
import * as lazyload from "react-lazyload";

if (window._mkt) {
  g.setGlobals({ ...window._mkt.g });
}

const storiesApi = {
  exec,
  g,
  api,
  proxy,
  dom,
  urls,
  at,
  features,
  enhancementsHelper,
  helpers,
  ajax,
  analytics,
  cookies,
  L10N,
  time,
  Logger,
  Componentes,
  mode,
  lazyload,
};

window.legacyContents = [
  "V2020-TRF",
  "V2020-SHOES-BAGS-HOMBRE",
  "V2020-SHOES-BAGS-TRF",
  "V2020-CORNERS",
  "V2020-CNY",
  "V2020-NYC",
  "V2020-LNY",
  "V2020-CNY-SHOES-BAGS",
  "V2020-CNY-NINOS",
  "V2020-LNY-NINOS",
  "V2020-LNY-SHOES-BAGS",
  "V2020-NYC-SHOES-BAGS",
  "V2020-NYC-NINOS",
  "V2020-CNY-VIDEO",
  "V2020-HOMBRE-CNY-VIDEO",
  "V2020-NINOS-NINA-CNY-VIDEO",
  "V2020-NINOS-NINO-CNY-VIDEO",
  "V2020-MUJER-CNY-VIDEO",
  "V2020-WECHAT-MINIP-HOT-SALE",
  "V2020-HOME-Header",
  "V2020-SHOES-BAGS-MUJER",
  "V2020-MUJER-EDITED",
  "V2020-HOMBRE-EDITED",
  "V2020-NINOS-EDITED-EDITORIAL",
  "V2020-MUJER-GALLERY",
  "W2020-MUJER-STORIES-THE-GALLERY",
  "V2020-MUJER-DAYLIGHT",
  "V2020-NINOS-STORIES-NEW-DENIM",
  "V2020-NINOS-MINI-RETRO-CAPSULE",
  "COMUN-SUSTAINABILITY-APP",
  "COMUN-SUSTAINABILITY-AU",
  "COMUN-SUSTAINABILITY-APP-BOXES-WITH-FUTURE",
  "I2019-CORNERS-EDITED-HOMBRE",
  "I2019-HOMBRE-EDITED",
  "I2019R-CORNERS-EDITED-HOMBRE",
  "I2019-CORNERS-MUJER-BEAUTY-ZARA-EMOTIONS",
  "I2019-SUSTAINABILITY",
  "I2019-ZARA-EMOTIONS",
  "I2019R-CORNERS-MUJER-BEAUTY-ZARA-EMOTIONS",
  "S2019-SUSTAINABILITY",
  "S2019-SUSTAINABILITY-BOXES-WITHA-FUTURE",
  "V2019-SUSTAINABILITY",
  "V2020-HOMBRE-JOIN-LIFE",
  "V2020-HOME-Header",
  "V2020-MUJER-ACCESORIOS-ZARA-EMOTIONS",
  "V2020-MUJER-JOIN-LIFE",
  "V2020-MUJER-STAY-MINIMAL-EDITORIAL",
  "V2020-MUJER-ZARA-EMOTIONS-EDITORIAL",
  "V2020-NINOS-JOIN-LIFE",
  "V2020-SUSTAINABILITY-COLECCION-NINOS",
  "W2019-SUSTAINABILITY",
  "W2020-SUSTAINABILITY-BOXES-WITHA-FUTURE",
  "ZH-V2020",
];

const isClosePage = document.querySelector("#CLOSE-PAGE");
const featureFlags = ["live-stylesheet-spot-enabled", "common-mkspots-disabled"];

const enabled = featureFlags.some(flag => window.zara?.viewPayload?.clientAppConfig?.enabledFeatures?.includes(flag));

const initMKT2 = () => {
  if (!window.zara?.viewPayload || window.zara?.viewPayload?.mktCategorySpot?.type !== "creativity") {
    exec({ storiesApi });
  }
};

window.__mkt2_init = debounce(initMKT2, 300);

if (g.channels.minip || g.channels.desktop || window.zara?.viewPayload?.clientAppConfig?.channel === "web" || isClosePage || enabled) {
  exec({ storiesApi });
}
